import PaymentStatus from '@/models/enums/PaymentStatus'
import PaymentType from '@/models/enums/PaymentType'
import PaymentMode from '@/models/enums/PaymentMode'
import DeliveryType from '@/models/enums/DeliveryType'

/** Кассовый платёж: успешный, не онлайн, не агрегаторский, режим не «оплата курьеру». Зеркало PaymentService::isCashierPayment */
export function isCashierPayment (order) {
  const payment = order?.payment
  if (!payment || payment.status !== PaymentStatus.Success) {
    return false
  }
  if (order.basket?.isAggregator || payment.type === PaymentType.Online || payment.type === PaymentType.AggregatorOnline) {
    return false
  }
  const deliveryType = order.deliveryType || order.basket?.deliveryType
  // mode null у старых платежей: дефолт по типу доставки, как PaymentMode::defaultFor()
  const mode = payment.mode || order.paymentMode ||
    (deliveryType === DeliveryType.Self ? PaymentMode.PayNow : PaymentMode.Courier)

  return mode !== PaymentMode.Courier
}
